<template>
  <div :class="rootClass">
    <input
      :class="inputClass"
      :value="value"
      :type="type"
      v-on="inputListeners"
      @input="handleChange"
      @focus="handleFocus"
      @blur="handleBlur"
      v-bind="$attrs"
      ref="input"
      :disabled="disabled"
    />
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    value: {
      default: null,
    },
    type: {
      type: String,
      default: 'text',
    },
    classes: {
      type: Object,
      default: () => ({ input: null }),
    },
    error: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      isFocus: false,
    }
  },
  computed: {
    rootClass () {
      return [this.$style.root, this.classes.root, {
        [this.$style.root_focus]: this.isFocus,
        [this.$style.root_hasError]: this.error,
        [this.$style.root_disabled]: this.disabled,
      }]
    },
    inputClass () {
      return [this.$style.input, this.classes.input]
    },
    inputListeners () {
      const { input, focus, blur, ...listeners } = this.$listeners
      return listeners
    },
  },
  methods: {
    handleChange (event) {
      this.$emit('input', event.target.value)
    },
    handleFocus (event) {
      this.isFocus = true
      this.$emit('focus', event)
    },
    handleBlur (event) {
      this.isFocus = false
      this.$emit('blur', event)
    },
    focus () {
      this.$refs.input.focus()
    },
    blur () {
      this.$refs.input.blur()
    },
  },
}
</script>

<style lang="scss" module>
.root {
  @apply relative;
  @apply inline-block;
  background-color: #ffffff40;
  transition: all .3s;
  @apply rounded-lg;
  @apply w-full;
  box-shadow: 0 0 1px 1px rgba(0,0,0,0.1);

  &::before {
    content: '';
    @apply absolute;
    @apply inset-0;
    @apply rounded-lg;
    z-index: -1;
    transition: all .3s;
    opacity: 0;
    box-shadow: 0 0 1px 2px rgba(0,0,0,0.2);
  }
}

.root_hasError {
  &::before {
    opacity: 1;
    box-shadow: 0 0 1px 2px rgba(255, 0, 0, 0.4);
  }
}

.root_focus {
  background-color: #ffffff80;

  &::before {
    opacity: 1;
  }
}

.root_disabled {
  background-color: transparent;

  .input {
    @apply cursor-not-allowed;
  }
}

.input {
  font-size: 2rem;
  @apply w-full;
  @apply px-6;
  @apply py-4;
  @apply rounded-lg;
  @apply border-0;
  @apply outline-none;
  background-color: transparent;
  box-sizing: border-box;
}
</style>
